import { BusinessEntityDto, BusinessEntityQueryOptions, BusinessPaymentMethod, fetchBusinessEntityList, getBusinessPaymentMethods } from "Hooks/Api/apiBusiness";
import { CustomerPaymentMethodDetails, getBusinessPaymentMethod } from "Hooks/Api/apiStripe";
import { EntityControllerData } from "Hooks/Api/shared";
import useAsync from "Hooks/useAsync";

// Query on single business payment
export function useApiBusinessPaymentMethod(businessId?: string) {

	const paymentMethodDetails = useAsync<CustomerPaymentMethodDetails | null>(async () => {
		if (businessId === undefined) return null;
		const response = await getBusinessPaymentMethod(businessId);
		return response.data;
	}, [businessId])

	return paymentMethodDetails;
}

export function useApiBusinessPayments(
	filterByOrgId?: string, 
	filterForEnabledMonitor?: boolean,
	filterForEnabledApprove?: boolean
) {

	const businessPaymentMethods = useAsync<BusinessPaymentMethod[]>(async () => {
		const response = await getBusinessPaymentMethods(filterByOrgId, filterForEnabledMonitor, filterForEnabledApprove);
		return response.data;
	}, [filterByOrgId, filterForEnabledMonitor, filterForEnabledApprove]);

	return businessPaymentMethods;
}

export function useApiBusinessEntityList(queryParams?: BusinessEntityQueryOptions) {
	const request = useAsync<EntityControllerData<BusinessEntityDto>>(async () => {
		const apiResponse = await fetchBusinessEntityList(queryParams);
		return apiResponse.data;
	}, [queryParams]);

	return request;
}

